import { Weapon } from '../../Weapon.js';
import { FUSED_WEAPONS } from '../../../../../config/constants.js';

/**
 * Cannonade (Harmonics fusion: Scatter Cannon + Spirit Lance) — a firing
 * rhythm rather than a single shot: pellet volleys with every Nth volley
 * replaced by a single heavy piercing slug (Scatter Cannon's cone, Spirit
 * Lance's pierce, one weapon). At max fusion level the slug comes every
 * 2nd volley instead of every 3rd.
 */
export class Cannonade extends Weapon {
  constructor() {
    super(FUSED_WEAPONS.cannonade);
    this._volleyCount = 0;
  }

  fire(origin, target, pool) {
    const dx = target.x - origin.x;
    const dy = target.y - origin.y;
    const dist = Math.hypot(dx, dy);
    if (dist === 0) return;
    const baseAngle = Math.atan2(dy, dx);

    this._volleyCount++;
    const slugEvery = this.level >= this.config.maxLevel ? 2 : this.config.slugEvery;
    if (this._volleyCount % slugEvery === 0) {
      pool.fire({
        x: origin.x,
        y: origin.y,
        vx: Math.cos(baseAngle) * this.config.slugSpeed,
        vy: Math.sin(baseAngle) * this.config.slugSpeed,
        radius: this.config.slugRadius,
        damage: this.config.slugDamage + this.level * this.config.slugDamagePerLevel,
        hits: 4,
        hitCooldownDuration: 0.05,
        lifetime: this.config.slugLifetime,
        color: '#ffffff',
      });
      return;
    }

    const pellets = this.config.pellets + Math.floor(this.level / 2);
    for (let i = 0; i < pellets; i++) {
      const t = pellets === 1 ? 0 : (i / (pellets - 1)) * 2 - 1;
      const angle = baseAngle + t * (this.config.spread / 2);
      pool.fire({
        x: origin.x,
        y: origin.y,
        vx: Math.cos(angle) * this.config.projectileSpeed,
        vy: Math.sin(angle) * this.config.projectileSpeed,
        radius: this.config.projectileRadius,
        damage: this.config.pelletDamage + this.level * this.config.pelletDamagePerLevel,
        hits: 1,
        lifetime: this.config.pelletLifetime,
        color: this.config.color,
      });
    }
  }
}
